<template>
  <div class="order-selector">
    <div
      class="order-selector__up"
      :class="{'active': active.order === 'asc' && active.column === column}"
      @click="setOrder('asc')"
    >
      <div class="triangle"></div>
    </div>
    <div
      class="order-selector__down"
      :class="{'active': active.order === 'desc' && active.column === column}"
      @click="setOrder('desc')"
    >
      <div class="triangle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderSelector',
  props: {
    column: {
      type: String,
    },
    active: {
      type: Object,
    },
  },
  methods: {
    setOrder(order) {
      this.isSameAsActive(order)
        ? this.$emit('onChange', { column: null, order: null })
        : this.$emit('onChange', { column: this.column, order: order });
    },
    isSameAsActive(order) {
      return this.active.column === this.column && this.active.order === order;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-selector {
  width: 2rem;
  align-self: stretch;
  display: flex;
  flex-direction: column;

  &__up {
    flex-grow: 1;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 0.1rem;

    .triangle {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 9px solid $grey;
    }

    &.active .triangle {
      border-bottom: 9px solid #4fde4d;
    }
  }

  &__down {
    flex-grow: 1;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 0.1rem;

    .triangle {
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 9px solid $grey;
    }

    &.active .triangle {
      border-top: 9px solid #4fde4d;
    }
  }
}
</style>